<template>
  <div class="question-form-container">
    <v-form @submit.prevent="submitQuestion">
      <v-textarea
        v-model="question"
        label="Question"
        required
        class="custom-textarea"
      ></v-textarea>
      
      <!-- Updated slider for summary length -->
      <v-slider
        v-model="summaryLength"
        :min="1"
        :max="5"
        :step="1"
        label="Length of summary"
        thumb-label
        class="mt-4 mb-4"
      >
        <template v-slot:prepend>
          <div class="text-caption">{{ summaryLength }} sentences</div>
        </template>
      </v-slider>
      
      <v-btn :loading="loading" type="submit" color="primary" class="mr-2">
        <span v-if="!loading">Submit</span>
        <span v-else>Loading...</span>
      </v-btn>
      <v-btn @click="clearQuestion" color="secondary">
        Clear
      </v-btn>
    </v-form>
  </div>
</template>

<script>
export default {
  props: {
    accessToken: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      question: '',
      loading: false,
      summaryLength: 3
    };
  },
  methods: {
    async submitQuestion() {
      if (!this.question.trim()) return;
      this.loading = true;
      try {
        const response = await fetch(`${process.env.VUE_APP_API_BASE_URL}/ask`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${this.accessToken}`
          },
          body: JSON.stringify({ 
            question: this.question,
            'summary-length': this.summaryLength
          })
        });
        const data = await response.json();
        if (!response.ok) {
          if (response.status === 401) {
            throw new Error('Authentication failed');
          }
          throw new Error(data.error || 'Unknown error occurred');
        }
        this.$emit('response-received', data, JSON.stringify(data, null, 2), response.status);
      } catch (error) {
        console.error('Error submitting question:', error);
        if (error.message === 'Authentication failed') {
          this.$emit('authentication-error');
        } else {
          this.$emit('response-received', { error: error.message }, null, 500);
        }
      } finally {
        this.loading = false;
      }
    },
    clearQuestion() {
      this.question = '';
    }
  }
};
</script>

<style scoped>
.question-form-container {
  position: relative;
}

.v-form {
  max-width: 600px;
  margin: 0 auto;
}

.custom-textarea {
  width: 600px !important;
}

.custom-textarea :deep(.v-field__input) {
  height: 200px !important;
  resize: vertical;
}
</style>